<template>
  <div class="period-item">
    <div class="period-item__picker">
      <range-picker-item
        v-model="model"
        :name="name"
        :disabled="disabled"
        :disabled-date="disabledDate"
        :errors="errors"
        :placeholder="placeholder"
        :rules="rules"
        @calendar-change="(dates, dateStrings, info) => $emit('calendar-change', dates, dateStrings, info)"
        @open-change="(status) => $emit('open-change', status)"
      />
    </div>
    <div v-if="!disabled" class="period-item__deleting-icon">
      <icon-delete @click="() => $emit('remove')"/>
    </div>
  </div>
</template>

<script setup>
  import { defineModel } from 'vue';
  import RangePickerItem from '@/components/form/components/RangePickerItem.vue';
  import IconDelete from '@/components/form/components/IconDelete.vue';

  const model = defineModel();

  defineProps({
    /**
     * Аттрибут name в HTML.
     */
    name: {
      type: Array,
      required: true,
    },

    /**
     * Правила валидации поля с периодом.
     */
    rules: {
      type: Object,
      reqired: true,
    },
    
    /**
     * Метка, что поле ввода отключено.DIGITAL-325
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * Определяет функцию, которая вычисляет, что дата не может быть выбрана.
     * Интерфейс функции: (currentDate: dayjs) => boolean
     */
    disabledDate: {
      type: Function,
      default: () => false,
    },
    
    /**
     * Объект ошибок для поля периода.
     */
    errors: Object,

    /**
     * Текст подсказки к полям ввода начала и окончания периода.
     */
    placeholder: {
      type: Array,
      default: () => ['', ''],
    },
  });

  defineEmits(['calendar-change', 'open-change', 'remove']);
</script>

<style lang="scss" scoped>
  .period-item {
    align-items: flex-start;
    display: flex;
    gap: 10px;

    .period-item__picker {
      flex: 1 0 auto;
    }

    .period-item__deleting-icon {
      display: flex;
      height: 40px;
      align-items: center;
    }
  }
</style>